import { AccountTypes } from '@am3nd-org/pointcraft-types';

export type WebSdkSyncFailureReason = 'TRANSIENT' | 'CLAIMS_MISSING';

const BUSINESS_SCOPED_ACCOUNT_TYPES = new Set<unknown>([
  AccountTypes.BUSINESS,
  AccountTypes.USER,
  AccountTypes.TERMINAL,
  AccountTypes.BUSINESS_DEVICE,
]);

/**
 * Claims are only definitively incomplete when the token identifies a
 * business-scoped principal and omits its business. Platform admins do not
 * require a businessId, and an unknown principal shape is not sufficient
 * evidence to force session recovery.
 */
export function hasRequiredWebSdkClaims(claims: Record<string, unknown>): boolean {
  if (!BUSINESS_SCOPED_ACCOUNT_TYPES.has(claims.accountType)) return true;
  return typeof claims.businessId === 'string' && claims.businessId.length > 0;
}

let failureReason: WebSdkSyncFailureReason | null = null;

export function clearWebSdkSyncFailure(): void {
  failureReason = null;
}

export function markWebSdkSyncFailure(reason: WebSdkSyncFailureReason): void {
  // Once the SDK is known to be authenticated without required claims, a later
  // transport failure must not hide that actionable state.
  if (failureReason === 'CLAIMS_MISSING' && reason === 'TRANSIENT') return;
  failureReason = reason;
}

export function needsWebSdkReauthentication(): boolean {
  return failureReason === 'CLAIMS_MISSING';
}

export function hasWebSdkSyncFailure(): boolean {
  return failureReason !== null;
}

export function getWebSdkSyncFailureReason(): WebSdkSyncFailureReason | null {
  return failureReason;
}
